import { createApi } from "@reduxjs/toolkit/query/react";

import apiConfig from "configs/apiConfig";
import { REDUCER_PATHS } from "store/config";
import { transformResponseHandler } from "utils/transformResponseHandler";

import { customFetchBase } from ".";

const managePromotionApi = createApi({
  reducerPath: REDUCER_PATHS.MANAGE_PROMOTION,
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    addPromotion: builder.mutation({
      query: (data) => ({
        url: process.env.REACT_APP_PROMOTION_URL,
        // url: apiConfig.ADD_PROMOTION,
        method: "POST",
        body: data,
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    editPromotion: builder.mutation({
      query: (data) => ({
        url: apiConfig.EDIT_PROMOTION + "/" + data?.id,
        body: data.data,
        method: "PUT",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),

    promotionListing: builder.query({
      query: (data) => ({
        url: apiConfig.PROMOTION_LIST,
        method: "POST",
        body: data,
      }),
    }),
    promotionDetails: builder.query({
      query: (data) => ({
        url: apiConfig.PROMOTION_DEATILS + data.id,
        method: "POST",
        body: data,
      }),
      //transformResponse: (resp) => transformResponseHandler(resp),
    }),
    deletePromotion: builder.mutation({
      query: (data) => ({
        url: apiConfig.DELETE_PROMOTION + data.id,
        method: "DELETE",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    brandAdminPromotionListing: builder.query({
      query: (data) => ({
        url: apiConfig.BRAND_ADMIN_PROMOTION_LIST,
        method: "POST",
        body: data,
      }),
    }),
    clubAdminPromotionListing: builder.query({
      query: (data) => ({
        url: apiConfig.CLUB_ADMIN_PROMOTION_LIST,
        method: "POST",
        body: data,
      }),
    }),

    getAllBenefitsListing: builder.mutation({
      query: () => ({
        url: apiConfig.GET_BENEFITS_LISTING,
        method: "POST",
      }),
    }),
  }),
});

export const {
  // useBrandAdminPromotionListingMutation,
  useLazyBrandAdminPromotionListingQuery,
  useLazyClubAdminPromotionListingQuery,
  // useClubAdminPromotionListingMutation,
  useAddPromotionMutation,
  useEditPromotionMutation,
  useDeletePromotionMutation,
  useGetAllBenefitsListingMutation,
  // usePromotionDetailsMutation,
  useLazyPromotionDetailsQuery,
  // usePromotionListingMutation,
  useLazyPromotionListingQuery,
} = managePromotionApi;

export default managePromotionApi;
